import React, { memo, useState } from 'react';
import { Tooltip } from '@Sage/hoi-poi-ui';
import PropTypes from 'prop-types';
import Ellipsis from 'react-ellipsis-component';

import './styles.scss';

const TruncatedLines = memo(({ text, className, maxLine = 2, onClick, ellipsis = '...' }) => {
    const [isClamped, setIsClamped] = useState(false);

    // `react-lines-ellipsis` defaulted `text` to ''; guard against undefined/null so the
    // JS ellipsis never writes the literal string "undefined" via innerText.
    const safeText = text ?? '';

    // `react-ellipsis-component` reports truncation via `onReflow(clamped, text)`.
    const handleReflow = (clamped) => {
        if (clamped) setIsClamped(true);
    };

    // Wrapper element is the DOM node the Tooltip attaches its ref + hover/focus handlers to
    // (the memoized `Ellipsis` component does not forward refs nor spread unknown props).
    // `trimRight` in `react-lines-ellipsis` mapped to `endExcludes` (drop trailing space before ellipsis).
    const content = (
        <div className="fm-truncated-lines" onClick={onClick}>
            <Ellipsis
                className={className}
                text={safeText}
                maxLine={maxLine}
                ellipsisNode={ellipsis}
                onReflow={handleReflow}
                endExcludes={[' ']}
            />
        </div>
    );

    if (!isClamped) return content;

    return (
        <Tooltip className="fm-tooltip" content={safeText}>
            {content}
        </Tooltip>
    );
});

TruncatedLines.displayName = 'TruncatedLines';

TruncatedLines.propTypes = {
    text: PropTypes.string,
    ellipsis: PropTypes.string,
    maxLine: PropTypes.number,
};

export default TruncatedLines;
